import { isNil, isFinite, replace } from "lodash";
import numeral from "numeral";

export const toReadableNumber = (num, currencySymbol = "$") => {
  return replace(numeral(num).format(`$0[.]0a`), "$", currencySymbol);
};

const getFteForTotalCost = (
  useDeltaForBudget,
  delta,
  prepopulatedValue,
  value,
  defaultedValue
) => {
  if (useDeltaForBudget) {
    return delta;
  }

  return !isNil(prepopulatedValue)
    ? prepopulatedValue
    : !isNil(value)
    ? value
    : defaultedValue;
};

// If the financial forecasting flag is not enabled, dailyRate will be null,
// the totalCost will be null too
export const calculateTotalCost = ({
  useDeltaForBudget = false,
  delta,
  prepopulatedValue,
  value,
  defaultedValue,
  dailyRate,
  workingDays,
}) => {
  const totalCostFte = getFteForTotalCost(
    useDeltaForBudget,
    delta,
    prepopulatedValue,
    value,
    defaultedValue
  );

  if (isNil(dailyRate)) {
    return null;
  }

  if (isFinite(dailyRate) && isFinite(workingDays) && isFinite(totalCostFte)) {
    return totalCostFte * dailyRate * workingDays;
  }

  return null;
};
